module.exports = __webpack_public_path__ + "img/ruwei.b4d02e44.svg";